/*
 * Mobile sticky Add to Cart bar.
 * Shows the bar once every primary buy control has scrolled above the viewport,
 * and hides it while any of them is on screen. Without this script the bar stays
 * hidden and the page buy box works as before.
 */
(() => {
  const bar = document.querySelector('[data-tv-sticky-atc]');
  if (!bar) return;

  const targets = [...document.querySelectorAll('gp-product-button')];
  if (!targets.length) targets.push(...document.querySelectorAll('product-form'));

  const scrollButton = bar.querySelector('[data-tv-sticky-scroll]');
  if (scrollButton) {
    scrollButton.addEventListener('click', () => {
      targets[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  if (!targets.length || !('IntersectionObserver' in window)) return;

  const states = new Map(targets.map((target) => [target, { onScreen: false, passed: false }]));

  const update = () => {
    let onScreen = false;
    let passed = false;
    states.forEach((state) => {
      if (state.onScreen) onScreen = true;
      if (state.passed) passed = true;
    });
    bar.classList.toggle('is-visible', !onScreen && passed);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      states.set(entry.target, {
        onScreen: entry.isIntersecting,
        passed: !entry.isIntersecting && entry.boundingClientRect.bottom < 0,
      });
    });
    update();
  });

  targets.forEach((target) => observer.observe(target));
})();
